<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form class="inline-form" inline>
          <el-form-item label="商户编号">
            <el-input
              class="search-input"
              v-model="merchantId"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户简称">
            <el-input
              class="search-input"
              v-model="merchantName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="直属代理商">
            <el-select
              class="search-input"
              v-model="agentId"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleAgentInfoFilter">
              <el-option
                v-for="item in subAgentInfoList"
                :key="item.fAgentId + item.fcreateTime"
                :label="item.fAgentId"
                :value="item.fAgentId">
                <span class="value">{{ item.fAgentId }}</span>
                <span class="name">{{ item.fTitle }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发展业务员">
            <el-select
              class="search-input"
              v-model="operatorAccount"
              placeholder="模糊搜索"
              clearable
              filterable
              :filter-method="handleSalesInfoFilter"
              :disabled="roleName == 'operator'">
              <el-option
                v-for="(item, index) in saleInfoList"
                :key="index"
                :label="item.fAgentAccount"
                :value="item.fAgentAccount">
                <span class="value">{{ item.fAgentAccount }}</span>
                <span class="name">{{ item.fName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form inline>
          <el-form-item label="报名状态">
            <el-select class="search-input" v-model="blueSeaStatus" clearable>
              <el-option label="报名失败" value="0"></el-option>
              <el-option label="报名通过" value="1"></el-option>
              <el-option label="审核中" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名通过时间">
            <el-date-picker
              v-model="auditTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button opt="download" type="text">
              <a href="static/蓝海行动报名流程.docx" download>活动规则下载</a>
            </auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 商户信息table -->
      <el-table
        stripe
        style="width:100%;"
        :data="blueSeaMerchantList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="index"
          label="序号"
          align="center"
          width="65">
        </el-table-column>
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center"
          min-width="160">
        </el-table-column>
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fAgentId"
          label="直属代理商"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fOperator"
          label="发展业务员"
          align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.fOperator || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="blueSeaStatus"
          label="报名状态"
          align="center"
          min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.blueSeaStatus | formatBlueSeaStatus }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="auditTime"
          label="报名通过时间"
          align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.auditTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fRemark"
          label="备注"
          align="center"
          min-width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.fRemark || '无' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fMsg"
          label="上报信息"
          align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.fMsg || '无' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="160">
          <template slot-scope="scope">
            <auth-button
              opt="edit"
              v-if="scope.row.canReport === 1"
              type="text"
              @click.native="handleEdit(scope.$index, scope.row)"
              label="编辑"></auth-button>
            <auth-button
              v-else
              opt="details"
              type="text"
              @click.native="handleInfo(scope.$index, scope.row)"
              label="查看"></auth-button>
            <auth-button
              type="text"
              opt="remark"
              @click.native="handleRemark(scope.$index, scope.row)"
              label="备注"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <el-dialog
      title="蓝海行动资料"
      :visible.sync="infoDialogVisible"
      width="1000px"
      center
      @close="$refs['participateInfoform'].resetFields()">
      <div v-loading="infoDialogLoading">
        <div class="reject-reson-view" v-if="participateInfo.statusMsg">审核退回原因：{{ participateInfo.statusMsg }}</div>
        <div>
          <h3>蓝海行动补充信息</h3>
          <el-form ref="participateInfoform" :model="participateInfo" :rules="participateInfoRules" label-width="100px" label-position="top">
            <!--            <el-form-item label="营业执照地址">-->
            <!--              <el-col :span="4">-->
            <!--                <el-form-item prop="provinceCode">-->
            <!--                  <el-select-->
            <!--                  class="dialog-form-item-margin-right"-->
            <!--                  v-model="participateInfo.provinceCode"-->
            <!--                  placeholder="请选择省"-->
            <!--                  clearable-->
            <!--                  filterable-->
            <!--                  :disabled="infoEditeDisable"-->
            <!--                  @change="handleProvinceChange">-->
            <!--                    <el-option-->
            <!--                      v-for="item in provinceList" -->
            <!--                      :key="item.areaCode" -->
            <!--                      :label="item.areaName" -->
            <!--                      :value="item.areaCode"></el-option>-->
            <!--                  </el-select>-->
            <!--                </el-form-item>-->
            <!--              </el-col>-->
            <!--              <el-col :span="4">-->
            <!--                <el-form-item prop="cityCode">-->
            <!--                  <el-select-->
            <!--                  class="dialog-form-item-margin-right"-->
            <!--                  v-model="participateInfo.cityCode"-->
            <!--                  placeholder="请选择市"-->
            <!--                  :loading="selectLoading"-->
            <!--                  clearable-->
            <!--                  filterable-->
            <!--                  :disabled="infoEditeDisable"-->
            <!--                  @focus="handleCityFocus"-->
            <!--                  @change="handleCityChange">-->
            <!--                    <el-option-->
            <!--                      v-for="item in cityList" -->
            <!--                      :key="item.areaCode" -->
            <!--                      :label="item.areaName" -->
            <!--                      :value="item.areaCode"></el-option>-->
            <!--                  </el-select>-->
            <!--                </el-form-item>-->
            <!--              </el-col>-->
            <!--              <el-col :span="4">-->
            <!--                <el-form-item prop="areaCode">-->
            <!--                  <el-select-->
            <!--                  class="dialog-form-item-margin-right"-->
            <!--                  v-model="participateInfo.areaCode"-->
            <!--                  placeholder="请选择区"-->
            <!--                  :loading="selectLoading"-->
            <!--                  clearable-->
            <!--                  filterable-->
            <!--                  :disabled="infoEditeDisable"-->
            <!--                  @focus="handleAreaFocus"-->
            <!--                  @change="handleAreaChange">-->
            <!--                    <el-option-->
            <!--                      v-for="item in areaList" -->
            <!--                      :key="item.areaCode" -->
            <!--                      :label="item.areaName" -->
            <!--                      :value="item.areaCode"></el-option>-->
            <!--                  </el-select>-->
            <!--                </el-form-item>-->
            <!--              </el-col>-->
            <!--            </el-form-item>-->
            <el-form-item label="证照信息">
              <el-col :span="6.5">
                <el-form-item prop="cashierDeskForAliPay">
                  <VueImgInputer
                    class="dialog-form-item-margin-right"
                    v-model="participateInfo.cashierDeskForAliPay"
                    theme="light"
                    accept="image/*"
                    @onChange="handleUpload('cashierDeskForAliPay')"
                    v-loading="picSelectInfo.cashierDeskForAliPayUploading"
                    placeholder="点击上传"
                    :max-size="picMaxSize"
                    :imgSrc="picSelectInfo.cashierDeskForAliPay"
                    :readonly="infoEditeDisable"></VueImgInputer>
                  <div class="form-image-title"><span v-if="!infoEditeDisable">*</span>收银台照(含支付宝相关物料)</div>
                </el-form-item>
              </el-col>
              <el-col :span="6.5">
                <el-form-item prop="thirdPlatformSettledPic">
                  <VueImgInputer
                    class="dialog-form-item-margin-right"
                    v-model="participateInfo.thirdPlatformSettledPic"
                    theme="light"
                    accept="image/*"
                    @onChange="handleUpload('thirdPlatformSettledPic')"
                    v-loading="picSelectInfo.thirdPlatformSettledPicUploading"
                    placeholder="点击上传"
                    :max-size="picMaxSize"
                    :imgSrc="picSelectInfo.thirdPlatformSettledPic"
                    :readonly="infoEditeDisable"></VueImgInputer>
                  <div class="form-image-title"><span v-if="!infoEditeDisable">*</span>第三方平台入驻照</div>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <div class="red-tip">备注:若商户信息中无营业执照请先补齐再申请参加蓝海行动，营业执照为蓝海行动必须资料</div>
        <div>
          <h3>商户入网信息</h3>
          <el-form ref="merchantInfoForm" :model="merchantInfo" label-width="100px" label-position="left">
            <el-form-item label-width="0">
              <el-col :span="7">
                <el-form-item label="法人姓名" prop="fApplicant">
                  <el-input class="dialog-form-item" v-model="merchantInfo.fApplicant" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="法人身份证" prop="fIdcard">
                  <el-input class="dialog-form-item-long" v-model="merchantInfo.fIdcard" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="7">
                <el-form-item label="商户全称" prop="fBusinessLicenseName">
                  <el-input class="dialog-form-item" v-model="merchantInfo.fBusinessLicenseName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="商户简称" prop="fMerchantName">
                  <el-input class="dialog-form-item" v-model="merchantInfo.fMerchantName" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="行业类型">
              <el-col :span="4">
                <el-form-item prop="fProvince">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fMccTypeValue"
                    clearable
                    filterable
                    disabled>
                    <el-option v-for="(item, index) in mcc_list" :label="item.grandpaTxt" :value="item.grandpaCode" :key="index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label-width="0" prop="fCity">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fMccCodeValue"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in groupList"
                      :key="item.mccCode"
                      :label="item.mccTxt"
                      :value="item.mccCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="营业执照号">
              <el-col :span="9">
                <el-form-item prop="fLicense">
                  <el-input class="dialog-form-item-long" v-model="merchantInfo.fLicense" disabled></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="4">
                <el-form-item prop="licenseChecked">
                  <el-checkbox-group style="display: inline;" v-model="merchantInfo.licenseChecked" disabled>
                    <el-checkbox label="暂无营业执照" name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col> -->
            </el-form-item>
            <el-form-item label="经营地址">
              <el-col :span="4">
                <el-form-item prop="fProvince">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fProvince"
                    placeholder="请选择省"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in provinceList"
                      :key="item.F_province_no"
                      :label="item.F_province_name"
                      :value="item.F_province_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="0" prop="fCity">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fCity"
                    placeholder="请选择市"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in cityList"
                      :key="item.F_city_no"
                      :label="item.F_city_name"
                      :value="item.F_city_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="0" prop="fArea">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fArea"
                    placeholder="请选择区"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in areaList"
                      :key="item.F_area_no"
                      :label="item.F_area_name"
                      :value="item.F_area_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label-width="0" prop="fAddress">
                  <el-input class="dialog-form-item-margin-right" v-model="merchantInfo.fAddress" placeholder="详细地址需超过5个字，精确到门牌号" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="客服电话" prop="fServicePhone">
              <el-input class="dialog-form-item" v-model="merchantInfo.fServicePhone" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <h3>结算信息</h3>
          <el-form ref="bankInfoform" :model="merchantInfo" label-width="100px" label-position="left">
            <el-form-item label-width="0">
              <el-col :span="7">
                <el-form-item label="账户类型" prop="fBankAccountType">
                  <el-select
                    class="dialog-form-item"
                    v-model="merchantInfo.fBankAccountType"
                    clearable
                    disabled>
                    <el-option label="对私账户" :value="1"></el-option>
                    <el-option label="对公账户" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="结算类型" prop="legalFlag">
                  <el-select
                    class="dialog-form-item"
                    v-model="merchantInfo.legalFlag"
                    clearable
                    disabled>
                    <el-option label="法人结算" :value="1"></el-option>
                    <el-option label="非法人结算" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="7">
                <el-form-item label="开户名" prop="fBankHolder">
                  <el-input class="dialog-form-item" v-model="merchantInfo.fBankHolder" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="开户人证件" prop="bankIdCard">
                  <el-input class="dialog-form-item-long" v-model="merchantInfo.bankIdCard" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label-width="0">
              <el-form-item label="开户号" prop="fBankAccount">
                <el-input class="dialog-form-item-long" v-model="merchantInfo.fBankAccount" disabled></el-input>
              </el-form-item>
            </el-form-item>
            <el-form-item label-width="0">
              <el-col :span="8">
                <el-form-item label="开户银行" prop="fBankName">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fBankName"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in provinceList"
                      :key="item.F_province_no"
                      :label="item.F_province_name"
                      :value="item.F_province_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="银行网点">
              <el-col :span="4">
                <el-form-item prop="fBankArea">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fBankArea"
                    placeholder="请选择省"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in provinceList"
                      :key="item.F_province_no"
                      :label="item.F_province_name"
                      :value="item.F_province_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="0" prop="fBankCity">
                  <el-select
                    class="dialog-form-item-margin-right"
                    v-model="merchantInfo.fBankCity"
                    placeholder="请选择市"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in cityList"
                      :key="item.F_city_no"
                      :label="item.F_city_name"
                      :value="item.F_city_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label-width="0" prop="fBankBranch">
                  <el-select
                    class="dialog-form-item-long"
                    v-model="merchantInfo.fBankBranch"
                    placeholder="分行网点(模糊查询)"
                    clearable
                    filterable
                    disabled>
                    <el-option
                      v-for="item in provinceList"
                      :key="item.F_province_no"
                      :label="item.F_province_name"
                      :value="item.F_province_name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="预留手机号" prop="fBankcardPhone">
              <el-input class="dialog-form-item" v-model="merchantInfo.fBankcardPhone" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <h3>证照信息</h3>
          <el-form :model="merchantInfoPics" inline>
            <el-form-item prop="idcardFrontUrl">
              <VueImgInputer
                v-model="merchantInfoPics.idcardFrontUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.idcardFront"
                readonly></VueImgInputer>
              <div class="form-image-title">法人身份证头像面</div>
            </el-form-item>
            <el-form-item prop="idcardBackUrl">
              <VueImgInputer
                v-model="merchantInfoPics.idcardBackUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.idcardBack"
                readonly></VueImgInputer>
              <div class="form-image-title">法人身份证国徽面</div>
            </el-form-item>
            <el-form-item prop="bankcardFrontUrl">
              <VueImgInputer
                v-model="merchantInfoPics.bankcardFrontUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.bankcardFront"
                readonly></VueImgInputer>
              <div class="form-image-title">银行卡正面/开户许可证</div>
            </el-form-item>
            <el-form-item prop="businessLicenseCUrl">
              <VueImgInputer
                v-model="merchantInfoPics.businessLicenseCUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.businessLicenseC"
                readonly></VueImgInputer>
              <div class="form-image-title">营业执照</div>
            </el-form-item>
            <el-form-item prop="doorPhotoUrl">
              <VueImgInputer
                v-model="merchantInfoPics.doorPhotoUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.doorPhoto"
                readonly></VueImgInputer>
              <div class="form-image-title">门头照</div>
            </el-form-item>
            <el-form-item prop="cashierDeskUrl">
              <VueImgInputer
                v-model="merchantInfoPics.cashierDeskUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.cashierDesk"
                readonly></VueImgInputer>
              <div class="form-image-title">收银台照</div>
            </el-form-item>
            <el-form-item prop="businessInsideUrl">
              <VueImgInputer
                v-model="merchantInfoPics.businessInsideUrl"
                theme="light"
                accept="image/*"
                placeholder="点击上传"
                :max-size="picMaxSize"
                :imgSrc="picSelectInfo.businessInside"
                readonly></VueImgInputer>
              <div class="form-image-title">经营场所照</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="infoDialogCancelClick">{{ infoEditeDisable ? '关 闭' : '取 消' }}</el-button>
        <el-button type="primary" v-if="!infoEditeDisable" @click="infoDialogSubmitClick">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import { hideBankCardNum, hideRealName, hidePhoneNum, hideIdCardNum } from '@/utils/hideSensitiveInfo.js'
import { uploadPic, mccGroupList, mccTypeList } from '@/api/global'
import { getBlueSeaMerchantList, subAgentInfo, queryAllSale, blueSeaArea, getBlueSeaInfo, merchantInfo, updateBlueSeaInfo, setBlueSeaRemark } from '@/api/merchant'
export default {
  name: 'BlueSeaMerchant',
  components: { VueImgInputer },
  data () {
    return {
      picDomain: 'https://pic.yeahka.com/',
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        auditTimeBegin: '',
        auditTimeEnd: '',
        FMerchantId: '',
        FMerchantName: '',
        FAgentId: '',
        FOperatorAccount: '',
        FMccCode: '',
        blueSeaStatus: ''
      },
      auditTime: '',
      merchantId: '',
      merchantName: '',
      agentId: '',
      operatorAccount: '',
      mccCode: '',
      blueSeaStatus: '',
      mccType: '',
      mcc_list: [], // 行业类型列表
      groupList: [],
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      saleInfoList: [],
      saleInfoList_back: [],
      blueSeaMerchantList: [],
      picMaxSize: 1024 * 3,
      infoDialogVisible: false,
      infoDialogLoading: false,
      infoEditeDisable: false,
      selectLoading: false,
      participateInfo: {
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        streetCode: '',
        address: '',
        cashierDeskForAliPay: '',
        thirdPlatformSettledPic: ''
      },
      participateInfoRules: {
        provinceCode: [
          { required: true, message: '请选择省', trigger: 'change' }
        ],
        cityCode: [
          { required: true, message: '请选择市', trigger: 'change' }
        ],
        areaCode: [
          { required: true, message: '请选择区', trigger: 'change' }
        ],
        streetCode: [
          // { required: true, message: '请选择街道', trigger: 'change' }
        ],
        address: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入详细地址'))
            } else {
              if (/(?!^\w+$)^.{5,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入5位以上详细地址'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        cashierDeskForAliPay: [
          { required: true, message: '请上传收银台照' }
        ],
        thirdPlatformSettledPic: [
          { required: true, message: '请上传第三方平台入驻照' }
        ]
      },
      merchantInfo: {},
      merchantInfoPics: {},
      picSelectInfo: {
        cashierDeskForAliPay: '',
        thirdPlatformSettledPic: ''
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: []
    }
  },
  mounted () {
    this.merchantId = this.$route.query.merchantId || ''

    this.searchClick()
    this.getMccTypeList()// 获取行业类型
    if (this.roleName !== 'operator') {
      this.getSubAgentInfo()
      this.querySaleList()
    }
  },
  methods: {
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
       * 筛选查询按钮点击
       */
    async searchClick (noReset) {
      this.searchInfo.auditTimeBegin = this.auditTime && this.auditTime[0] ? this.auditTime[0] : ''
      this.searchInfo.auditTimeEnd = this.auditTime && this.auditTime[1] ? this.auditTime[1] : ''
      this.searchInfo.FMerchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.FMerchantName = this.merchantName.replace(/ /g, '') || ''
      this.searchInfo.FAgentId = this.agentId || ''
      this.searchInfo.FOperatorAccount = this.operatorAccount || ''
      this.searchInfo.FMccCode = this.mccCode || ''
      this.searchInfo.blueSeaStatus = this.blueSeaStatus || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      await this.getBlueSeaMerchantList()
    },
    /**
       * 删除提交参数中的空字段
       */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
       * 选择行业类型获取焦点
       */
    handleGroupFocus () {
      if (this.mccType) {
        this.getGroupList(this.mccType)
      }
    },
    /**
       * 直属代理商自定义筛选方法
       */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    /**
       * 业务员账号自定义筛选方法
       */
    handleSalesInfoFilter (queryString) {
      if (queryString) {
        this.saleInfoList = this.saleInfoList_back.filter(item => {
          return item.fAgentAccount.toLowerCase().includes(queryString.toLowerCase()) || item.fName.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.saleInfoList = this.saleInfoList_back
      }
    },
    /**
       * 信息查看点击
       */
    handleInfo (index, row) {
      console.log(`index: ${index}, row: `, row)
      this.infoDialogVisible = true
      this.infoEditeDisable = true
      this.getDetailInfo(row)
    },
    /**
       * 信息编辑点击
       */
    handleEdit (index, row) {
      console.log(`index: ${index}, row: `, row)
      this.infoDialogVisible = true
      this.infoEditeDisable = false
      this.getDetailInfo(row)
    },
    /**
       * 备注点击
       */
    handleRemark (index, row) {
      this.$prompt('', '备注信息', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputPattern: /^\S{1,20}$/,
        inputPlaceholder: '20字内',
        inputErrorMessage: '请输入最多20字非空白字符',
        inputType: 'textarea'
      }).then(async ({ value }) => {
        await this.setRemark(row.fMerchantId, value)
        this.searchClick()
      })
    },
    /**
       * 请求详细信息
       */
    async getDetailInfo (row) {
      this.infoDialogLoading = true
      this.participateInfo = {
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        streetCode: '',
        address: '',
        cashierDeskForAliPay: '',
        thirdPlatformSettledPic: ''
      }
      this.merchantInfo = {}
      this.picSelectInfo = {}
      // this.setLocationList('province', 1)
      await Promise.all([this.getMerchantInfo(row.fMerchantId), this.getBlueSeaInfo(row.fMerchantId)])
      this.participateInfo.merchantId = row.fMerchantId
      // this.setLocationList('city', this.participateInfo.provinceCode)
      // this.setLocationList('area', this.participateInfo.cityCode)
      // this.setLocationList('street', this.participateInfo.areaCode)
      this.infoDialogLoading = false
    },
    /**
       * 省份选择Change
       */
    handleProvinceChange (value) {
      this.participateInfo.cityCode = ''
      this.participateInfo.areaCode = ''
      this.participateInfo.streetCode = ''
      this.participateInfo.address = ''
    },
    /**
       * 市选择Change
       */
    handleCityChange (value) {
      this.participateInfo.areaCode = ''
      this.participateInfo.streetCode = ''
      this.participateInfo.address = ''
    },
    /**
       * 区选择Change
       */
    handleAreaChange (value) {
      this.participateInfo.streetCode = ''
      this.participateInfo.address = ''
    },
    /**
       * 街道选择Change
       */
    handleStreetChange (value) {
      this.participateInfo.address = ''
    },
    /**
       * 选择城市获取焦点
       */
    handleCityFocus () {
      this.setLocationList('city', this.participateInfo.provinceCode)
    },
    /**
       * 选择地区获取焦点
       */
    handleAreaFocus () {
      this.setLocationList('area', this.participateInfo.cityCode)
    },
    /**
       * 选择街道获取焦点
       */
    handleStreetFocus () {
      this.setLocationList('street', this.participateInfo.areaCode)
    },
    /**
       * 根据上级街道获取并设置区域列表
       * @param {String} type 要设置的区域类型
       * @param {String} areaCode 上级区域代码
       */
    async setLocationList (type, areaCode) {
      if (areaCode) {
        this[`${type}List`] = await this.queryArea(areaCode) || []
      }
    },
    /**
       * 上传照片
       */
    handleUpload (type) {
      this.picSelectInfo[`${type}Uploading`] = true
      const picFile = this.participateInfo[type]
      const reader = new FileReader()
      reader.readAsDataURL(picFile)
      reader.onload = () => {
        const file = reader.result.split('base64,')
        const params = qs.stringify({
          base64pic: file[1],
          picType: type
        })
        // console.log(params)
        uploadPic(params).then(response => {
          console.log('uploadPic response:', response)
          this.picSelectInfo[`${type}Uploading`] = false
          if (response.error_code === '0') {
            this.$message({
              message: response.error_msg,
              type: 'success'
            })
            this.participateInfo[type] = response.path
            this.picSelectInfo[type] = response.showPath
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      }
    },
    /**
       * 信息dialog确定点击
       */
    infoDialogSubmitClick () {
      console.log('信息确定点击')
      this.$refs.participateInfoform.validate(valid => {
        if (valid) {
          this.$confirm('请确认是否提交审核', '提示', {
            type: 'warning'
          }).then(async () => {
            await this.updateDetailInfo()
            this.infoDialogVisible = false
            this.searchClick(true)
          })
        } else {
          console.log('error submit!!')
          this.$message({
            message: '提交信息有误，请完善后重新提交',
            type: 'error'
          })
          return false
        }
      })
    },
    /**
       * 信息dialog取消点击
       */
    infoDialogCancelClick () {
      if (this.infoEditeDisable) {
        this.infoDialogVisible = false
        return
      }
      this.$confirm('请确认是否放弃当前修改内容', '提示', {
        type: 'warning'
      }).then(() => {
        this.infoDialogVisible = false
      })
    },
    /**
       * 查询蓝海行动商户列表
       */
    getBlueSeaMerchantList () {
      return new Promise((resolve, reject) => {
        const params = qs.stringify(this.searchInfo)
        getBlueSeaMerchantList(params).then(response => {
          if (response.error_code === '0') {
            this.blueSeaMerchantList = response.list
            this.paginations.count = response.totalCount
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
       * 获取行业类型
       */
    getGroupList (mccType) {
      return new Promise((resolve, reject) => {
        console.log(mccType)
        this.selectLoading = true
        mccGroupList({
          grandpaCode: mccType
        }).then(response => {
          console.log('getGroupList response:', response)
          this.selectLoading = false
          if (response.error_code === '0') {
            this.groupList = response.list
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
       * @description 获取下级代理商下拉列表
       */
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        subAgentInfo('pageSize=65535').then(response => {
          if (response.error_code === '0') {
            const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            const agentList = [{
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }]
            this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
        })
      })
    },
    /**
       * @description 获取业务员下拉列表
       */
    querySaleList () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        queryAllSale('pageSize=65535').then(response => {
          if (response.error_code === '0') {
            this.saleInfoList = response.list
            this.saleInfoList_back = [...this.saleInfoList]
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        }).catch(() => {
        })
      })
    },
    /**
       * 获取省市区
       */
    queryArea (areaCode = '1') {
      return new Promise((resolve, reject) => {
        this.selectLoading = true
        const params = qs.stringify({ areaCode: areaCode })
        console.log(params)
        blueSeaArea(params).then(response => {
          console.log('queryArea response:', response)
          this.selectLoading = false
          resolve(response)
        })
      })
    },
    /**
       * 查询蓝海行动资料
       */
    getBlueSeaInfo (merchantId) {
      return new Promise((resolve, reject) => {
        const params = qs.stringify({ merchantId: merchantId })
        console.log(params)
        getBlueSeaInfo(params).then(response => {
          console.log('getBlueSeaInfo response:', response)
          if (response.error_code === '0') {
            this.participateInfo = response.data
            // 清空编辑中已有的营业执照地址信息，再次提交就为空了
            this.participateInfo.area = ''
            this.participateInfo.areaCode = ''
            this.participateInfo.province = ''
            this.participateInfo.provinceCode = ''
            this.participateInfo.city = ''
            this.participateInfo.cityCode = ''
            this.picSelectInfo.cashierDeskForAliPay = this.picDomain + response.data.cashierDeskForAliPay
            this.picSelectInfo.thirdPlatformSettledPic = this.picDomain + response.data.thirdPlatformSettledPic
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
       * 查询商户信息
       */
    getMerchantInfo (merchantId) {
      return new Promise((resolve, reject) => {
        const params = qs.stringify({ merchantId: merchantId })
        console.log(params)
        merchantInfo(params).then(response => {
          console.log('getMerchantInfo response:', response)
          if (response.error_code === '0') {
            this.merchantInfo = response.basic
            this.merchantInfo.realfApplicant = this.merchantInfo.fApplicant
            this.merchantInfo.fApplicant = hideRealName(this.merchantInfo.fApplicant)
            this.merchantInfo.realfIdcard = this.merchantInfo.fIdcard
            this.merchantInfo.fIdcard = hideIdCardNum(this.merchantInfo.fIdcard)
            this.merchantInfo.realfServicePhone = this.merchantInfo.fServicePhone
            this.merchantInfo.fServicePhone = hidePhoneNum(this.merchantInfo.fServicePhone)
            this.merchantInfo.realfBankHolder = this.merchantInfo.fBankHolder
            this.merchantInfo.fBankHolder = hideRealName(this.merchantInfo.fBankHolder)
            this.merchantInfo.realbankIdCard = this.merchantInfo.bankIdCard
            this.merchantInfo.bankIdCard = hideIdCardNum(this.merchantInfo.bankIdCard)
            this.merchantInfo.realfBankAccount = this.merchantInfo.fBankAccount
            this.merchantInfo.fBankAccount = hideBankCardNum(this.merchantInfo.fBankAccount)
            this.merchantInfo.realfBankcardPhone = this.merchantInfo.fBankcardPhone
            this.merchantInfo.fBankcardPhone = hidePhoneNum(this.merchantInfo.fBankcardPhone)
            this.picSelectInfo = Object.assign(this.picSelectInfo, response.pics)
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
       * 提交参加蓝海行动资料
       */
    updateDetailInfo () {
      return new Promise((resolve, reject) => {
        this.infoDialogLoading = true
        const params = qs.stringify(this.participateInfo)
        console.log(params)
        updateBlueSeaInfo(params).then(response => {
          console.log('updateDetailInfo response:', response)
          this.infoDialogLoading = false
          if (response.error_code === '0') {
            this.$message({
              message: '资料提交成功',
              type: 'success'
            })
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    /**
       * 设置备注
       */
    setRemark (merchantId, remark) {
      return new Promise((resolve, reject) => {
        const params = qs.stringify({
          merchantId: merchantId,
          remark: remark
        })
        console.log(params)
        setBlueSeaRemark(params).then(response => {
          console.log('blueSeaSetRemark response:', response)
          if (response.error_code === '0') {
            this.$message({
              message: '添加备注成功',
              type: 'success'
            })
            resolve()
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      })
    },
    // 获取行业类型
    getMccTypeList () {
      const data = qs.stringify({})
      mccTypeList(data).then(response => {
        if (response.error_code === '0') {
          this.mcc_list = response.data
        } else {
          this.$message({
            message: response.error_msg,
            type: 'warning'
          })
        }
      })
    }
  },
  computed: {
    roleName () {
      return this.$store.getters.roleName
    }
  },
  filters: {
    formatBlueSeaStatus (value) {
      switch (value) {
        case 0:
          return '报名失败'
        case 1:
          return '报名通过'
        case 2:
          return '审核中'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @mixin flex-horizontal {
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .main-view {
    padding-left: 16px;
  }
  .search-input {
    width: 160px;
  }
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
  .dialog-form-item-view {
    @include flex-horizontal;
  }
  .dialog-form-item {
    width: 160px;
    margin-right: 15px;
  }
  .dialog-form-item-long {
    width: 300px;
    margin-right: 15px;
  }
  .dialog-form-item-short {
    width: 120px;
    margin-right: 15px;
  }
  .dialog-form-item-margin-right {
    margin-right: 10px;
  }
  .form-image-title {
    line-height: 26px;
    text-align: center;
    span {
      color: red;
    }
  }
  .reject-reson-view {
    font-weight: bold;
  }
  .red-tip {
    color: red;
  }
  .file-download-button {
    color: blue;
    text-decoration: underline;
    margin-left: 10px;
  }
</style>
